import { GlobalStore } from '@roc/client-portal-shared/stores';
import { FormStore, UserStore } from '@roc/feature-app-core';
import {
  DateFormat,
  formatDate,
  GENERIC_ERROR_MESSAGE,
  insertIf,
} from '@roc/feature-utils';
import { DialogState } from '@roc/ui';
import {
  action,
  computed,
  flow,
  makeObservable,
  observable,
  override,
} from 'mobx';
import { GeneralTasksService } from '../services/generalTasksService';
import {
  Assignee,
  GeneralTaskAttachment,
  GeneralTaskComment,
  PopulateTaskFormField,
  GeneralTaskType,
  Task,
  TaskTypeForm,
  TaskScopeForm,
  TaskStatusDB,
} from '../types/generalTasksTypes';
import { appraisalTaskTypes, ASSIGN_TO_NOT_VALID_PRE_MESSAGE, lineItemsTaskTypes, REASSIGN_NOT_VALID_PRE_MESSAGE, taskTypeOptions } from '../utils/generalTasksConstants';
import { createEmptyTask } from '../utils/generalTasksUtils';
import { GeneralTasksAttachmentStore } from './generalTasksAttachmentStore';
import { GeneralTasksCommentStore } from './generalTasksCommentStore';
import { GeneralTasksStore } from './generalTasksStore';
import { UserOption } from '@roc/feature-communication';
import { LoanService } from '@roc/feature-loans';

const form = {
  fields: {
    title: {
      value: '',
      error: null,
      rule: 'required',
    },
    description: {
      value: '',
      error: null,
      rule: '',
    },
    status: {
      value: TaskStatusDB.PENDING,
      error: null,
      rule: 'required',
    },
    priority: {
      value: '',
      error: null,
      rule: '',
    },
    sectionName: {
      value: null,
      error: null,
      rule: '',
    },
    assigneeRequired: {
      value: false,
      error: null,
      rule: ''
    },
    taskScope: {
      value: TaskScopeForm.EXTERNAL,
      error: null,
      rule: 'required',
    },
    loanId: {
      value: '',
      error: null,
      rule: '',
    },
    watchIds: {
      value: null,
      error: null,
      rule: '',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class TechTaskFormStore extends FormStore {

  constructor(
    globalStore: GlobalStore
  ) {
    super(form, globalStore);

    makeObservable(this, {});
  }

}
